//
// Entry point for the build script in your package.json
//

// Load Rails stuff
//require("@rails/activestorage").start()

// Load / init turbo
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo
Turbo.config.drive.progressBarDelay = 200

// Hack to scroll to top (default behavior) without animation on turbo:render
window.addEventListener("turbo:render", () => {
  Turbo.navigator.currentVisit.scrolled = true;
  window.scrollTo({top: 0, behavior: "instant"})
});

// Redirect on 403 and 429 errors to show the user the proper
// error page even if the error is triggered inside a turbo-frame
// request.
window.addEventListener("turbo:before-fetch-response", (e) => {
  let response = e.detail.fetchResponse
  let mustRedirect = response.failed && (response.statusCode == 403 || response.statusCode == 429)
  let redirectUrl = response.response.url

  if (mustRedirect) {
    e.preventDefault()
    window.location.href = redirectUrl
  }
});

// Load / init stimulus controllers from ./stimulus/index.js
import "./stimulus"

// Load ALTCHA widget (bot challenge) with German translations.
// English is built in.
import "altcha"
import "altcha/i18n/de"

// Load bootstrap
import "bootstrap"
// Load bootstrap-icons
//import "bootstrap-icons/bootstrap-icons.svg"

// Load / init axios
import axios from "axios"
const csrfToken = document.querySelector("meta[name=csrf-token]").content
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
axios.defaults.headers.common["X-CSRF-Token"] = csrfToken
document.addEventListener("turbo:render", () => {
  const csrfToken = document.querySelector("meta[name=csrf-token]").content
  axios.defaults.headers.common["X-CSRF-Token"] = csrfToken
})

